// console.log("loading the footer");

$(function(){
    //app download popup

    var deviceType = $('.app-download-sms-link').data('deviceType');

    $('.app-download-sms-link').modal({
        url : "/fw/dialog/AppDownload.jsp?deviceType=" + deviceType,
        onComplete : function(){

            $(".app-download-form:visible").submit(function(e){
                e.preventDefault();
                var inputField = $(".sms_phone_num:visible");
                var number = inputField.val();
                if(!hasValidPhoneNum(number)){
                    inputField.parent().addClass("is-error");
                    $('.sms_phone_num_error').slideDown();
                    return;
                }else{
                    inputField.parent().removeClass("is--error");
                    $('.sms_phone_num_error').slideUp();
                }
                var data = $.param({
                    phoneNum : number,
                    deviceType : deviceType
                });
                $('.send-sms:visible').prop("disabled","disabled");

                $.post("/fw/ajax/SendAppDownloadSMS.jsp", data, function(data){
                    $.ajax({
                        type: 'GET',
                        url: '/fw/content/user/appDownloaderNotification',
                        success: function (data) {
                            $('body').append(data);
                            $.modal({triggerOpen:true, open: "app-download-sms-notification-modal"});
                        },
                        failure: function () {
                        }
                    });
             })
        });

            $(".sms_phone_num:visible").on("input", function(e){
                if(hasValidPhoneNum($(this).val())){
                    $(this).parent().removeClass("is--error");
                } else{
                    $(this).parent().addClass("is--error");
                }
            });
            function hasValidPhoneNum(number){
                return /^\+?\d+$/.test(number.replace(/[()-]/g, ''));
            }
        }
    });
});


// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/footer/index.js